<template>
  <div class="flex-col">
   <h1 class="m-0">
      <slot></slot>
    </h1>
  </div>

</template>

<script>
export default {
  name: "DashboardPageHeader",
}
</script>


